// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridContainer_hmtyy {
  display: grid;
  gap: 12px;
}

.signInOption_z3CTW {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  background-color: var(--f1-background);
  width: 100%;
  border-radius: 6px;
  height: 30px;
}

.serverConfigContainer_p8vvJ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  column-gap: 24px;
}

.dropdownContainer_b1oS0 {
  display: flex;
  flex-direction: column;
}

.dropdownContainer_b1oS0 label {
  font-weight: 700;
}



.eye_W7SLD {
  width: 20px;
  height: 20px;
}

/* .scaleInCenter {
	animation: scaleInCenter 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  bottom: 37%;
  right: 38%;
  background-color: var(--white-background);
  height: 200px;
  width: 200px;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes scaleInCenter {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
} */

.checkOk_kNXhq {
  font-size: 15px;
  color: var(--white-color);
  animation: checkOk_kNXhq 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@keyframes checkOk_kNXhq {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.loader_UPxrB {
  width: 20px;
  height: 20px;
  border: 2px solid var(--white-color);
  border-bottom-color: var(--_10a37f-background);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation_AMeV5 1s linear infinite;
  }

  @keyframes rotation_AMeV5 {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/GmailFormCreateAutomate/ModalAddConnectionGmail.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;EACE,eAAe;EACf,yBAAyB;EACzB,2EAAqE;AACvE;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4CAAsC;EACtC;;EAEA;EACA;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;EACA","sourcesContent":[".gridContainer {\n  display: grid;\n  gap: 12px;\n}\n\n.signInOption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  background-color: var(--f1-background);\n  width: 100%;\n  border-radius: 6px;\n  height: 30px;\n}\n\n.serverConfigContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  column-gap: 24px;\n}\n\n.dropdownContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdownContainer label {\n  font-weight: 700;\n}\n\n\n\n.eye {\n  width: 20px;\n  height: 20px;\n}\n\n/* .scaleInCenter {\n\tanimation: scaleInCenter 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n  bottom: 37%;\n  right: 38%;\n  background-color: var(--white-background);\n  height: 200px;\n  width: 200px;\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n  -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes scaleInCenter {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n} */\n\n.checkOk {\n  font-size: 15px;\n  color: var(--white-color);\n  animation: checkOk 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n\n@keyframes checkOk {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.loader {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--white-color);\n  border-bottom-color: var(--_10a37f-background);\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `gridContainer_hmtyy`,
	"signInOption": `signInOption_z3CTW`,
	"serverConfigContainer": `serverConfigContainer_p8vvJ`,
	"dropdownContainer": `dropdownContainer_b1oS0`,
	"eye": `eye_W7SLD`,
	"checkOk": `checkOk_kNXhq`,
	"loader": `loader_UPxrB`,
	"rotation": `rotation_AMeV5`
};
export default ___CSS_LOADER_EXPORT___;
